import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../../../utils/events'
import { ActionSelect } from '../../../../../Action'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../../Checkbox'
import { EntityArchivedIcon } from '../../../../../Entity'
import {
  QA_NAME_LISTING_BOARD_CARD_ACTIONS,
  QA_NAME_LISTING_BOARD_CARD_SELECT,
} from '../../RentalPortalListingsBoard.constants'

import * as styles from './RentalPortalListingsBoardCardHead.module.css'

import Archive2Icon from '../../../../../../icons/archive-2.svg'

function RentalPortalListingsBoardCardHead({
  actions,
  archived,
  isSelectable,
  isSelected,
  selectNotAllowedTooltip,
  onClickAction,
  onSelect,
}) {
  const { t } = useTranslation()

  const selectLabel = t('RentalPortal.BoardCardSelectKey')

  return (
    <div className={styles.RentalPortalListingsBoardCardHead}>
      {onSelect ? (
        <div onClick={stopPropagation}>
          <Checkbox
            checked={isSelected}
            disabled={!isSelectable}
            label={selectLabel}
            labelClassName={styles.selectLabel}
            qaName={QA_NAME_LISTING_BOARD_CARD_SELECT}
            size={CHECKBOX_SIZE.small}
            tooltip={isSelectable ? selectLabel : selectNotAllowedTooltip}
            type={CHECKBOX_TYPE.table}
            onChange={onSelect}
          />
        </div>
      ) : null}
      <div className={styles.actions}>
        {archived ? <EntityArchivedIcon Icon={Archive2Icon} /> : null}
        {actions.length > 0 ? (
          <div onClick={stopPropagation}>
            <ActionSelect
              actions={actions}
              controlProps={{
                buttonProps: {
                  Button: Button.Text,
                  height: BUTTON_HEIGHT_24,
                  qaName: QA_NAME_LISTING_BOARD_CARD_ACTIONS,
                },
              }}
              qaName={QA_NAME_LISTING_BOARD_CARD_ACTIONS}
              onClickAction={onClickAction}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default RentalPortalListingsBoardCardHead
